import * as React from 'react';
import { type RootState, useSelector } from '../../../state';
import { selectors as foundingSelectors } from '../../../state/founding';
import { StepContainer } from '../Container';
import { StepHeading } from '../step-heading';

function selector(state: RootState) {
  return {
    brregProcessingTime: state.app.brregProcessingTime,
    singleSigner: foundingSelectors.hasSingleSigner(state),
  };
}

export const AltinnStep: React.FC = () => {
  const { brregProcessingTime, singleSigner } = useSelector(selector);
  const waitTime = brregProcessingTime || 8;
  return (
    <StepContainer>
      <StepHeading>Vent på SMS fra&nbsp;Altinn</StepHeading>

      {singleSigner ? (
        <p>I løpet av få timer får du en melding fra Altinn om å signere.</p>
      ) : (
        <p>
          I løpet av få timer får dere en melding fra Altinn om å signere. For å
          komme videre må alle gjøre dette.
        </p>
      )}
      <p>
        Når {singleSigner ? 'signaturen' : 'signaturene'} er på plass kan
        Brønnøy&shy;sund&shy;registrene behandle søknaden din! Akkurat nå bruker
        de {waitTime} virkedager.
      </p>
    </StepContainer>
  );
};
